






















































import Vue from "vue";
import moment from "moment";
import { FetchInstallationsNetworkMetricsReqData } from "@/model/communication/networkMetrics/FetchInstallationsNetworkMetricsCommand";
import { mapGetters } from "vuex";

export default Vue.extend({
    data() {
        return {
            startDatePicker: null,
            endDatePicker: null,
            radioSelection: 0,
            defaultDateRanges: [
                {
                    id: "lastWeek",
                    i18nLabel: "network_metrics.lastWeek",
                    value: 0,
                },
                {
                    id: "lastMonth",
                    i18nLabel: "network_metrics.lastMonth",
                    value: 1,
                },
                {
                    id: "last3Months",
                    i18nLabel: "network_metrics.last3Months",
                    value: 2,
                },
                {
                    id: "customDateRange",
                    i18nLabel: "",
                    value: 3,
                },
            ],
        };
    },
    props: {
        value: Object as () => FetchInstallationsNetworkMetricsReqData,
    },
    computed: {
        ...mapGetters(["userDateFormat"]),
        dateRangeFormatted() {
            if (this.dateRange == null || this.dateRange == undefined || this.dateRange.length == 0) return this.dateRange;
            let dateRangeString = "";
            this.dateRange.forEach((date) => {
                dateRangeString += moment(date).format(this.userDateFormat) + ",";
            });
            return dateRangeString.slice(0, -1);
        },
        filter: {
            get: function () {
                var res;
                if (this.value) res = this.value;
                else res = [];
                return res;
            },
            set: function (newValue) {
                if (newValue) {
                    this.$emit("input", newValue);
                } else {
                    this.$emit("input", null);
                }
            },
        },
        dateRange: {
            get() {
                var res = [];
                if (this.startDatePicker) res.push(this.startDatePicker.toISOString().substr(0, 10));
                if (this.endDatePicker) res.push(this.endDatePicker.toISOString().substr(0, 10));
                return res;
            },
            set(v: number[]) {
                if (v.length == 1) {
                    this.startDatePicker = new Date(v[0]);
                    this.endDatePicker = null;
                } else {
                    const a = new Date(v[0]);
                    const b = new Date(v[1]);
                    if (a < b) {
                        this.startDatePicker = a;
                        this.endDatePicker = b;
                    } else {
                        this.startDatePicker = b;
                        this.endDatePicker = a;
                    }

                    this.endDatePicker.setUTCHours(23);
                    this.endDatePicker.setUTCMinutes(59);
                    this.endDatePicker.setUTCSeconds(59);

                    this.filter.webSocketMetricStartDate = this.startDatePicker as Date;
                    this.filter.webSocketMetricEndDate = this.endDatePicker as Date;
                }
            },
        },
    },
    watch: {
        radioSelection(value) {
            let startDateTemp = null;
            let endDateTemp = new Date();

            if (value != 3) {
                this.startDatePicker = null;
                this.endDatePicker = null;
            }

            switch (value) {
                case 0:
                    startDateTemp = moment().subtract(1, "weeks").utc();
                    break;
                case 1:
                    startDateTemp = moment().subtract(1, "months").utc();
                    break;
                case 2:
                    startDateTemp = moment().subtract(3, "months").utc();
                    break;

                default:
                    break;
            }

            this.filter.webSocketMetricStartDate = startDateTemp as Date;
            this.filter.webSocketMetricEndDate = endDateTemp as Date;
        },
    },
    methods: {
        handleInput(value) {
            this.$emit("input", value);
        },
    },
});
